import styled from '@emotion/styled'
import { css } from '@emotion/react'

export const LanguageSelectorContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  border: 1px solid ${({ theme }) => theme.colors.grey[2]};
  border-radius: 8px;
  width: fit-content;
  background: #FFFFFF;
  position: relative;
  cursor: pointer;
  user-select: none;
`

export const SelectedValue = styled.span`
  ${({ theme }) => css(theme.typographys.small.regular)}
  color: ${({ theme }) => theme.colors.neutrals.b};
`

export const DropdownList = styled.ul<{ isOpen: boolean }>`
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  position: absolute;
  bottom: calc(100% + 4px);
  left: 0;
  z-index: 100;
  background: ${({ theme }) => theme.colors.neutrals.w};
  border: 1px solid ${({ theme }) => theme.colors.grey[2]};
  border-radius: 8px;
  padding: 4px 0;
  margin: 0;
  list-style: none;
  min-width: 160px;
  max-height: 220px;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
`

export const DropdownItem = styled.li<{ isSelected: boolean }>`
  padding: 8px 12px;
  cursor: pointer;
  ${({ theme }) => css(theme.typographys.small.regular)}
  color: ${({ theme }) => theme.colors.neutrals.b};
  background: ${({ theme, isSelected }) =>
    isSelected ? theme.colors.grey[1] : 'transparent'};

  &:hover {
    background: ${({ theme }) => theme.colors.grey[1]};
  }
`
